import { render, staticRenderFns } from "./Structurer.vue?vue&type=template&id=6cd91330&scoped=true"
import script from "./Structurer.vue?vue&type=script&lang=js"
export * from "./Structurer.vue?vue&type=script&lang=js"
import style0 from "./Structurer.vue?vue&type=style&index=0&id=6cd91330&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd91330",
  null
  
)

export default component.exports